<!-- Incluir clase "active" según corresponda -->
<div
  class="tabs"
  [ngClass]="{
    w4: isDealWithInsurance && isAvailableInsurancePayments,
    w3: isDealWithInsurance && !isAvailableInsurancePayments,
    w2: !isDealWithInsurance
  }"
>
  <a (click)="selectSection(1)" [ngClass]="{ active: showSection == 1 }">Información contractual</a>
  <!-- <a (click)="selectSection(2)" [ngClass]="{'active': showSection == 2}">Pagos especiales</a> -->
  <a (click)="selectSection(3)" [ngClass]="{ active: showSection == 3 }">Amortizaciones ({{ currencySelected() }})</a>
  @if(isDealWithInsurance){
  <a (click)="selectSection(4)" [ngClass]="{ active: showSection == 4 }">Seguro</a>
  } @if(isAvailableInsurancePayments){
  <a (click)="selectSection(5)" [ngClass]="{ active: showSection == 5 }"
    >Amortizaciones Seguro ({{ currencySelected() }})</a
  >
  }
</div>

<!-- Información contractural -->
<div class="contract" *ngIf="showSection == 1">
  <div class="mainWrapper">
    <!-- Parámetros -->
    <div class="parameters">
      <!-- General -->
      <div class="general">
        <div class="control">
          <!-- Producto financiero -->
          <label>Producto financiero</label>
          <span>{{ financialCalculator.getFinancialProduct(_deal.financialProductType) }}</span>
        </div>

        <!-- Plazo -->
        <div class="control">
          <label>Plazo</label>
          <span>{{ _deal.term }}</span>
        </div>

        <!-- Segmento OPEX -->
        <div class="control">
          <label>Segmento OPEX</label>
          <span>{{ financialCalculator.getSegmentOpex(_deal.opexSegment) }}</span>
        </div>

        <!-- Moneda -->
        <div class="control">
          <label>Moneda</label>
          <div>
            <span>{{ _deal.currencyType }}</span>
          </div>
        </div>

        <!-- Cotización USD -->
        <div class="control">
          <label>Cotización USD</label>
          <div>
            <span>{{ _deal.quoteUsd }}</span>
          </div>
        </div>

        <!-- IVA -->
        <div class="control">
          <label>IVA</label>
          <div>
            <span>{{ _deal.tax }}</span>
            <span>%</span>
          </div>
        </div>

        <!-- Exento IVA -->
        <div class="control">
          <label>Exento IVA</label>
          <div>
            <span>{{ !getTaxFree(_deal) ? 'NO' : 'SI' }}</span>
          </div>
        </div>

        @if (featureLoyaltyFeriaQuotation) {
        <div class="control">
          <label>Loyalty (propuesta)</label>
          <span>{{ dealLoyaltyReadonlyYesNo() }}</span>
        </div>
        }

        <!-- Tasa al cliente -->
        <div class="control">
          <label>Tasa al cliente</label>
          <div>
            <span>{{ _deal.customerRate }}</span>
            <span>%</span>
          </div>
        </div>
      </div>

      <!-- Información vehículo -->
      <div class="vehicle">
        <!-- Datos -->
        <div class="data">
          <div class="row">
            <!-- Tipo de producto -->
            <div class="col">
              <label>Tipo de producto</label>
              <span>{{ financialCalculator.getProductType(_deal.productType) }}</span>
            </div>
            <!-- @if(isManualInsurance()){
            <div class="col">
              <label>Condición</label>
              <span>{{ !_deal.classification ? 'No aplica' : _deal.classification == 'NEW' ? 'Nuevo' : 'Usado' }}</span>
            </div>
            }  -->
            @if(!isManualInsurance()){
            <!-- Check modelo de catálogo -->
            <div class="col">
              <label class="checkboxWrapper">
                <input type="checkbox" [checked]="_deal.includesInsurance" disabled />
                <span class="checkmark"></span>
                <span class="description">Modelo de catálogo con opción de seguro broker</span>
              </label>
            </div>
            }
          </div>

          @if(isDealWithInsurance){
          <!-- Opciones para modelo de catálogo -->
          <div class="catalog">
            <div class="row">
              <!-- Condición -->
              @if(!isManualInsurance()){
              <div class="col">
                <label>Condición</label>
                <span>{{
                  !_deal.classification ? 'No aplica' : _deal.classification == 'NEW' ? 'Nuevo' : 'Usado'
                }}</span>
              </div>
              }
              <!-- Tiempo de uso -->
              @if(!isManualInsurance()){
              <div class="col">
                <label>Tiempo de uso</label>
                <span>XX Meses</span>
              </div>
              }
            </div>

            <div class="row">
              <!-- Cantidad -->
              <div class="col">
                <label>Cantidad</label>
                <span>{{ _deal.quantity }}</span>
              </div>
              <!-- Año -->
              @if(!isManualInsurance()){
              <div class="col">
                <label>Año</label>
                <span>{{ model?.year }}</span>
              </div>
              }
            </div>

            @if(!isManualInsurance()){
            <div class="row">
              <!-- Modelo -->
              <div class="colX2">
                <label>Modelo</label>
                <span>{{ model?.name }}</span>
              </div>
            </div>

            } @if(!isManualInsurance()){
            <div class="row">
              <!-- Marca  -->
              <div class="col">
                <label>Marca</label>
                <span>{{ brand?.name }}</span>
              </div>
              <!-- Submarca -->
              <div class="col">
                <label>Submarca</label>
                <span>{{ subBrand?.name }}</span>
              </div>
            </div>
            }
          </div>
          } @else {
          <!-- Opciones para modelo fuera de catálogo -->
          <div class="noCatalog">
            @if(!isManualInsurance()){

            <div class="row">
              <!-- Marca -->
              <div class="col">
                <label>Marca</label>
                <span>{{ brand?.name }}</span>
              </div>
              <!-- Submarca -->
              <div class="col">
                <label>Submarca</label>
                <span>{{ subBrand?.name }}</span>
              </div>
            </div>
            }
            <div class="row">
              <!-- Condición -->
              <div class="col">
                <label>Condición</label>
                <span>{{
                  !_deal.classification ? 'No aplica' : _deal.classification == 'NEW' ? 'Nuevo' : 'Usado'
                }}</span>
              </div>
              <!-- Tiempo de uso -->
              <div class="col">
                <label>Tiempo de uso</label>
                <div>
                  <span>{{ _deal.useTime }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- Cantidad -->
              <div class="col">
                <label>Cantidad</label>
                <span>{{ _deal.quantity }}</span>
              </div>
              <!-- Características -->
              <div class="col">
                <label>Caracteristicas</label>
                <span>{{ _deal.feature }}</span>
              </div>
            </div>
          </div>
          }
        </div>

        <!-- Imagen -->
        @if(!isManualInsurance()){
        <div class="photo">
          <div class="wrapper">
            @if (subBrandImg; as imgUrl) {
            <!-- Si tiene imagen mostrar picture-->
            <picture>
              <img src="{{ imgUrl }}" alt="Marca Submarca" />
            </picture>
            } @else {
            <!-- Si no tiene imagen mostrar div.noImage-->
            <div class="noImage">
              <span>Sin imagen</span>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <!-- Condiciones -->
      <div class="conditions">
        <!-- Precio unitario -->
        <div class="row">
          <div class="wrapperS1">
            <div class="wrapperSX">
              <label>Precio unitario</label>
              <span class="note">Sin IVA</span>
            </div>
          </div>
          <div class="wrapperS2">
            <span class="amountReadOnly xl">{{ _deal.unitPriceWithoutTax | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
          <div class="wrapperSX">
            <span class="note">Con IVA</span>
            <span class="amountReadOnly xl">{{ _deal.unitPriceWithTax | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>

        <!-- Total venta -->
        <div class="row">
          <div class="wrapperS1">
            <div class="wrapperSX">
              <label>Total venta</label>
              <span class="note">Sin IVA</span>
            </div>
          </div>
          <div class="wrapperS2">
            <span class="amountReadOnly xl">{{ _deal.totalPriceWithoutTax | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
          <div class="wrapperSX">
            <span class="note">Con IVA</span>
            <div>
              <span class="amountReadOnly xl">{{ _deal.totalPriceWithTax | currency : '' : '' }}</span>
              <span>{{ currencySelected() }}</span>
            </div>
          </div>
        </div>

        <!-- Enganche -->
        <div class="rowGroup" *ngIf="_deal.financialProductType != 'PURE_LEASING'">
          <div class="row join">
            <div class="wrapperS1">
              <label>Enganche</label>
            </div>
            <div class="wrapperSX">
              <div class="innerWrapper">
                <span class="note">{{ financialCalculator.getTaxType(_deal.downPaymentTaxType) }}</span>
                <span>{{ _deal.downPaymentTax }}</span>
                <span *ngIf="_deal.downPaymentTax">%</span>
              </div>
            </div>
          </div>
          <!-- Enganche (línea 2)-->
          <div class="row">
            <div class="wrapperS1">
              <div class="wrapperSX">
                <label></label>
                <span class="note">Sin IVA</span>
              </div>
            </div>
            <div class="wrapperS2">
              <span class="amountReadOnly xl">{{
                _deal?.result?.downpaymentAmount / (1 + _deal?.tax / 100) | currency : '' : ''
              }}</span>
              <span>{{ currencySelected() }}</span>
            </div>
            <div class="wrapperSX">
              <span class="note">Con IVA</span>
              <div>
                <span class="amountReadOnly xl">{{ _deal?.result?.downpaymentAmount | currency : '' : '' }}</span>
                <span>{{ currencySelected() }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Monto a financiar -->
        <div class="row">
          <div class="wrapperS1">
            <label>Monto a financiar</label>
          </div>
          <div class="wrapperSX flexEnd">
            <span class="amountReadOnly xl">{{ (_deal?.result?.financialAmount ?? _deal?.financialAmount) | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>

        <!-- Comisión por apertura -->
        <div class="rowGroup">
          <div class="row join">
            <div class="wrapperS1">
              <label>Comisión por apertura</label>
            </div>
            <div class="wrapperS4">
              <span class="note">{{ financialCalculator.getTaxType(_deal.openingFeeType) }}</span>
              <span>{{ _deal.openingFeePercentage }}</span>
              <span *ngIf="_deal.openingFeePercentage">%</span>
            </div>
          </div>
          <!-- Comisión por apertura (línea 2)-->
          <div class="row">
            <div class="wrapperS1">
              <div class="wrapperSX">
                <label></label>
                <span class="note">Sin IVA</span>
              </div>
            </div>
            <div class="wrapperS2">
              <span class="amountReadOnly xl">{{
                _deal?.result?.openingfeeAmount / (1 + _deal.tax / 100) | currency : '' : ''
              }}</span>
              <span>{{ currencySelected() }}</span>
            </div>
            <div class="wrapperSX">
              <span class="note">Con IVA</span>
              <div>
                <span class="amountReadOnly xl">{{ _deal?.result?.openingfeeAmount | currency : '' : '' }}</span>
                <span>{{ currencySelected() }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Depósitos en garantía -->
        <div class="row">
          <div class="wrapperS1">
            <label>Depósitos en garantía</label>
          </div>
          <div class="wrapperSX">
            <div class="innerWrapper">
              <span class="note">{{ financialCalculator.getTaxType(_deal.warrantyDeposit) }}</span>
              <div>
                <span>{{ _deal.warrantyDepositPercentage }}</span>
                <span *ngIf="_deal.warrantyDepositPercentage">%</span>
              </div>
            </div>
            <div class="innerWrapper">
              <span class="amountReadOnly xl">{{
                _deal.warrantyDeposit == taxType.numberOfRents
                  ? _deal.warrantyDepositMonth
                  : !_deal.warrantyDeposit
                  ? 'No aplica'
                  : (_deal.warrantyDepositTotal | currency : '' : '')
              }}</span>
              <span *ngIf="_deal.warrantyDepositTotal || _deal.warrantyDepositMonth">{{
                _deal.warrantyDeposit == taxType.numberOfRents ? 'Mensualidades' : currencySelected()
              }}</span>
            </div>
          </div>
        </div>

        <!-- Subsidio -->
        <div class="row">
          <div class="wrapperS1">
            <label>Subsidio</label>
          </div>
          <div *ngIf="_deal.subsidyTotal; else notApply" class="wrapperSX">
            <div class="innerWrapper">
              <span class="note">{{ financialCalculator.getTaxType(_deal.subsidyType) }}</span>
              <div>
                <span>{{ _deal.subsidyPercentage }}</span>
                <span *ngIf="_deal.subsidyPercentage">%</span>
              </div>
            </div>
            <div class="innerWrapper">
              <span class="gapRight">{{ _deal.subsidyTotal | currency : '' : '' }}</span>
              <span *ngIf="_deal.subsidyTotal">{{ currencySelected() }}</span>
            </div>
          </div>
          <ng-template #notApply>
            <div class="selectWrapper size2">
              <span>No aplica</span>
            </div>
          </ng-template>
        </div>

        <!-- Balloon -->
        @if(isShowBalloon){
        <div class="row">
          <div class="wrapperS1">
            <label>Balloon</label>
          </div>
          @if(_deal.balloonType && !isBalloonFixedAmount){
            <div class="wrapperSX">
              <div class="innerWrapper">
                <span>{{ _deal.balloonPercentage ?? 0 }}</span>
                <span>%</span>
              </div>
              <div class="innerWrapper">
                <span class="amountReadOnly xl">{{ _deal.balloon | currency : '' : '' }}</span>
                <span>{{ currencySelected() }}</span>
              </div>
            </div>
          } @else if(_deal.balloonType && isBalloonFixedAmount){
            <div class="innerWrapper">
              <span>{{ _deal.balloon | currency : '' : '' }}</span>
              <span>{{ currencySelected() }}</span>
            </div>
          }@else {
            <div class="selectWrapper size2">
              <span>No aplica</span>
            </div>
          }
        </div>
        }

        <!-- Valor residual -->
        <div class="row" *ngIf="_deal.financialProductType == financialProduct.pureLease">
          <div class="wrapperS1">
            <label>Valor residual</label>
          </div>
          <div class="wrapperSX">
            <div class="innerWrapper">
              <span class="note">{{ financialCalculator.getTaxType(_deal.residualValueType) }}</span>
              <span>{{ _deal.residualValuePercentage }}</span>
              <span *ngIf="_deal.residualValuePercentage">%</span>
            </div>
            <div class="innerWrapper">
              <span class="gapRight">{{ _deal.residualValueTotal | currency : '' : '' }}</span>
              <span *ngIf="_deal.residualValueTotal">{{ currencySelected() }}</span>
            </div>
          </div>
        </div>

        <!-- Opción de compra -->
        <div class="row" *ngIf="_deal.financialProductType == financialProduct.financialLeasing">
          <div class="wrapperS1">
            <label>Opción de compra</label>
          </div>
          <div class="wrapperSX">
            <div class="innerWrapper">
              <span class="note">{{ financialCalculator.getTaxType(_deal.purchaseOptionType) }}</span>
              <span>{{ _deal.purchasePercentage }}</span>
              <span *ngIf="_deal.purchasePercentage">%</span>
            </div>
            <div class="innerWrapper">
              <span class="gapRight">{{ _deal.purchaseTotal | currency : '' : '' }}</span>
              <span *ngIf="_deal.purchaseTotal">{{ currencySelected() }}</span>
            </div>
          </div>
        </div>

        <!-- Tipo de pago -->
        <div class="row">
          <div class="wrapperS1">
            <label>Tipo de pago</label>
          </div>
          <div class="wrapperSX">
            <div class="innerWrapper">
              <span>{{ _deal.paymentType == 'REGULAR_PAYMENT' ? 'Anticipado' : 'Vencimiento' }}</span>
            </div>
          </div>
        </div>

        <!-- Forma de amortización -->
        <div class="row">
          <div class="wrapperS1">
            <label>Forma de amortización</label>
          </div>
          <div class="wrapperSX">
            <div class="innerWrapper">
              <span>{{ _deal.paymentFormationType == 'LEVELED' ? 'Nivelada' : 'Descendente' }}</span>
            </div>
          </div>
        </div>

        <!-- Gastos de ratificación -->
        <div class="row">
          <div class="wrapperS1">
            <label>Gastos de ratificación</label>
          </div>
          <div class="wrapperSX flexEnd">
            <span class="gapRight">{{ _deal.confirmationExpensesAmount | currency : '' : '' }}</span>
            <span *ngIf="_deal.confirmationExpensesAmount">{{ currencySelected() }}</span>
          </div>
        </div>

        <!-- Factor seguro de vida -->
        <div class="row">
          <div class="wrapperS1">
            <label>Factor seguro de vida</label>
          </div>
          <div class="wrapperSX">
            <div class="innerWrapper">
              {{ _deal.lifeInsuranceFactor | currency : '' : '' }}
            </div>
          </div>
        </div>

        <!-- Colateral adicional -->
        <div class="row" *ngIf="_deal.financialProductType == financialProduct.directCredit">
          <div class="wrapperS1">
            <label>Colateral adicional</label>
          </div>
          <div *ngIf="_deal.additionalCollateralTotal; else notApply" class="wrapperSX">
            <div class="innerWrapper">
              <span class="note">{{ financialCalculator.getTaxType(_deal.additionalCollateralType) }}</span>
              <div>
                <span>{{ _deal.additionalCollateralPercentage }}</span>
                <span *ngIf="_deal.additionalCollateralPercentage">%</span>
              </div>
            </div>
            <div class="innerWrapper">
              <span>{{ _deal.additionalCollateralTotal | currency : '' : '' }}</span>
              <span *ngIf="_deal.additionalCollateralTotal">{{ currencySelected() }}</span>
            </div>
          </div>
          <ng-template>
            <div class="selectWrapper size2">
              <span>No aplica</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Parámetros Seguro Broker -->
  @if(isDealWithInsurance){
  <div class="module insurance openQuote">
    <div class="title">
      <div>
        <h3>Seguro</h3>
      </div>
    </div>
    <div class="wrapper">
      @if(insuranceType){
      <div>
        <label>Tipo de seguro</label>
        <span>{{ insuranceType.description }}</span>
      </div>
      } @if(insurance?.stateName; as stateName){
      <div>
        <label>Estado</label>
        <span>{{ stateName.toLowerCase() }}</span>
      </div>
      } @if(insuranceUse){
      <div>
        <label>Uso</label>
        <span>{{ insuranceUse.description }}</span>
      </div>
      }@if(loadType){
      <div>
        <label>Tipo de carga</label>
        <span>{{ loadType }}</span>
      </div>
      }

      <!--
        @if(insurance?.postalCode; as postalCode){
          <div>
            <label>Código postal</label>
            <span>{{ postalCode }}</span>
          </div>
        }
        -->
      @if(insurance?.quantityPassengers; as quantity){
      <div>
        <label>Cantidad de pasajeros</label>
        <span>{{ quantity }}</span>
      </div>
      }
    </div>
  </div>
  }
</div>
<!-- <div *ngIf="showSection == 2" class="payments">
</div> -->

<!-- Amortizations -->
<div *ngIf="showSection == 3">
  <app-payments
    [payments]="_deal.payments"
    [quantity]="_deal.quantity"
    [currency]="currency"
    [readOnly]="true"
    [specialPayments]="_deal.specialPayments"
    [grace]="gracePeriod"
    [irregularPayments]="_deal.irregularPayments"
    [tipoProductoFinanciero]="_deal.financialProductType"
  >
  </app-payments>
</div>

<div *ngIf="showSection == 4">
  <app-insurance-list-payments [coverage]="insurance" [quantity]="_deal.quantity"></app-insurance-list-payments>
</div>

<div *ngIf="showSection == 5">
  <app-insurance-amortizations
    [payments]="insurancePayments"
    [quantity]="_deal.quantity"
    [currency]="currency"
    [readOnly]="true"
    [tipoProductoFinanciero]="_deal.financialProductType"
    [grace]="_deal.grace"
  ></app-insurance-amortizations>
</div>
